import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { categories } from '@/mocks/categories'

const colorMap: Record<string, string> = {
  accent: 'bg-accent-100 text-accent-600 hover:bg-accent-200',
  primary: 'bg-primary-100 text-primary-600 hover:bg-primary-200',
  secondary: 'bg-secondary-100 text-secondary-600 hover:bg-secondary-200',
}

export default function CategoriesSection() {
  const { t } = useTranslation('common')

  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="mx-auto px-4 md:px-6 max-w-7xl">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mb-3">
            {t('home.categoriesTitle')}
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            {t('home.categoriesSubtitle')}
          </p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-3 md:gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center gap-3 p-5 md:p-6 rounded-2xl bg-background-100 hover:bg-primary-50 transition-all duration-300"
            >
              <div className={`w-12 h-12 md:w-14 md:h-14 rounded-2xl ${colorMap[cat.color]} flex items-center justify-center group-hover:scale-110 transition-transform duration-300`}>
                <i className={`${cat.icon} text-xl md:text-2xl`}></i>
              </div>
              <span className="font-heading text-sm md:text-base text-foreground-800 text-center whitespace-nowrap">
                {cat.name}
              </span>
              <span className="text-xs text-foreground-400">
                {cat.count.toLocaleString()}{t('category.videoCount')}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  )
}